import { render, staticRenderFns } from "./middle2.vue?vue&type=template&id=389e6dd4&scoped=true&"
import script from "./middle2.vue?vue&type=script&lang=js&"
export * from "./middle2.vue?vue&type=script&lang=js&"
import style0 from "./middle2.vue?vue&type=style&index=0&id=389e6dd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e6dd4",
  null
  
)

export default component.exports